import axios, { AxiosError, AxiosResponse } from 'axios';
import { BACKEND_URL } from '../env';
import { ShowToast } from '../services/toast';

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const getToken = () => {
  const token = localStorage.getItem('token');
  if (token) {
    return `Bearer ${token}`;
  }
  return null;
};

export const handleUnauthorizedResponse = (
  errorMessage?: string,
  responseUrl?: string,
  forceLoginRedirect = false
) => {
  if (errorMessage === 'bad login' || responseUrl?.includes('/admin/my') || forceLoginRedirect) {
    localStorage.removeItem('token');
    if (window.location.pathname !== '/login' && window.location.pathname !== '/provider/login') {
      window.location.replace('/login');
    }
  } else {
    ShowToast({
      type: 'error',
      message: 'Something went wrong',
    });
  }
};

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  if (error.response?.status === 401) {
    // Google login owns this error so it can explain whether the account is
    // unauthorized, unregistered, or missing admin access without also showing
    // the interceptor's generic duplicate toast.
    if (error.config?.url?.includes('/auth/google')) {
      return Promise.reject(error);
    }

    // Only use the server message to recognize the existing expired-session signal.
    const data = error.response.data;
    const errorMessage =
      typeof data === 'object' &&
      data !== null &&
      'message' in data &&
      typeof data.message === 'string'
        ? data.message
        : undefined;
    handleUnauthorizedResponse(errorMessage, error?.request?.responseURL);
  }
  return Promise.reject(error);
};

const apiClient = axios.create({
  baseURL: BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: '*/*',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(onResponse, onResponseError);

export default apiClient;
